import { render } from "./ErrorFlashMessage.vue?vue&type=template&id=6ec65fb7&scoped=true"
import script from "./ErrorFlashMessage.vue?vue&type=script&lang=js"
export * from "./ErrorFlashMessage.vue?vue&type=script&lang=js"

import "./ErrorFlashMessage.vue?vue&type=style&index=0&id=6ec65fb7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec65fb7"]])

export default __exports__